import React from "react";
import { useNavigate } from "react-router-dom";
import EmployeesTable from "./EmployeesTable";
import { Box, HStack, VStack } from "../../components/utils";
import JoiningYear from "./joiningYear";
import { useEmployees } from "../../queries/employees";
import Department from "./department";
import EmployeeTableFilters from "./employeeTableFilters";
import BCHeader from "../../shared/BCHeader";
import { usePermissionStore } from "../../store/permissionStore";
import { determineUserAccessToResource } from "../../utils/auth";
import useIsMobile from "../../utils/detectDevice";
import {
  Action as DefaultAction,
  Resource,
} from "../../utils/interfaces/Companies";

function AllEmployees(): React.ReactElement {
  const navigate = useNavigate();
  const { isMobile } = useIsMobile();
  const { isPlaceholderData, isFetching, data: _data } = useEmployees();
  const { permission } = usePermissionStore();

  return (
    <VStack className={`gap-4 ${isPlaceholderData ? "loading" : ""} `}>
      <BCHeader
        className={`items-baseline ${isMobile ? "text-xs" : ""}`}
        bcTitle="Stakeholders"
        buttonName="Add Option Holder"
        disabled={
          !determineUserAccessToResource(
            permission?.aclList || [],
            Resource.Employee,
            DefaultAction.Create
          )
        }
        onClick={() =>
          navigate("/options/employees/new", {
            state: { returnTo: "/options/allEmployees" },
          })
        }
        bcDescription="Detailed listing and profiles of participants featuring individual award histories and current holdings."
      />
      <Box
        className={`grid w-full border border-borderColor drop-shadow-box ${
          isMobile ? "grid-cols-1" : "grid-cols-2"
        } gap-4 rounded-lg `}
      >
        <Department title="Departments" />
        <JoiningYear title="Year of Joining" />
      </Box>
      <HStack className="w-full gap-4">
        <Box className={`${isMobile ? "w-full overflow-x-auto" : "grow"} `}>
          {<EmployeesTable />}
        </Box>
      </HStack>
    </VStack>
  );
}

export default AllEmployees;
